import React, {createContext, useEffect, useMemo, useReducer, useState} from 'react';
import {InitialStateProps} from '../interface';
import {globalReducer} from '../reducers/globalReducer';
import { initialState } from '../assets/constants/constants';


export const AppContext = createContext<{
  state: InitialStateProps;
  dispatch: React.Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null,
});
export const AppProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Simulate an asynchronous check for authentication
    const checkAuthStatus = async () => {
      const token = localStorage.getItem('token');
      if (token && token?.trim() !== '') {
        dispatch({type: 'IS_AUTH', payload: true});
      } else {
        dispatch({type: 'IS_AUTH', payload: false});
      }
      setLoading(true);
    };
    checkAuthStatus();
  }, []);
  return (
    <AppContext.Provider value={useMemo(() => ({state, dispatch}), [state, dispatch])}>
      {loading && children}
    </AppContext.Provider>
  );
};
